let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("isLXN")).then(() => parcelRequire('ciHbV'));